import t from 'tcomb';

const newUser = t.struct({   
        companyName: t.String,
        country: t.String,
        parentCoName: t.String,
        websiteUrl: t.String,
        address: t.String,
        phone: t.Number,
        city: t.String,
        stateOpt: t.String,
        zip: t.String,
        contactName: t.String,
        jobTitle: t.String,
        emailAddress: t.String,
        confirmEmailAddress: t.String,

},{
        name: 'State',
        strict: true
});

export const getDefaultState = () =>
    new newUser({
            companyName: "",
            country: "",
            parentCoName: "",
            websiteUrl: "",
            address: "",
            phone: 0,
            city: "",
            stateOpt: "",
            zip: "",
            contactName: "",
            jobTitle: "",
            emailAddress: "",
            confirmEmailAddress: ""
    });

export default newUser;